var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRLogoLine = function SvgRLogoLine(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.086 137.564",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h30.956c6.125 10.608 64.774 99.29 85.13 131.564H3C3 124.239 3.213 15.135 3 3h61.912c38.519 0 46.434 24.669 46.434 38.7s-7.959 38.7-46.434 38.7H3v54.174c12.32-18.57 51.138-82.9 56.5-90.934v90.934H3V3",
    fill: "none",
    stroke: "#6490fd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRLogoLine);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjIuMDg2IDEzNy41NjQiPjxwYXRoIGQ9Ik0zIDNoMzAuOTU2YzYuMTI1IDEwLjYwOCA2NC43NzQgOTkuMjkgODUuMTMgMTMxLjU2NEgzQzMgMTI0LjIzOSAzLjIxMyAxNS4xMzUgMyAzaDYxLjkxMmMzOC41MTkgMCA0Ni40MzQgMjQuNjY5IDQ2LjQzNCAzOC43cy03Ljk1OSAzOC43LTQ2LjQzNCAzOC43SDN2NTQuMTc0YzEyLjMyLTE4LjU3IDUxLjEzOC04Mi45IDU2LjUtOTAuOTM0djkwLjkzNEgzVjMiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzY0OTBmZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiLz48L3N2Zz4=";